// extracted by mini-css-extract-plugin
module.exports = {"sso":"login_sso__LdrXs","content":"login_content__CAPqu","heading":"login_heading__yp6yH","btnNext":"login_btnNext__QLyvB"};